// T-185 — le REPRÉSENTANT du bénéficiaire (nom, prénom, fonction, e-mail, téléphone), repris en base à la conversion d'un prospect (`dossier.representant`).
// Affiché dans le bloc Client de la fiche dossier. DÉRIVÉ DE LA DONNÉE : aucun nom de tenant ; sans donnée, le composant ne rend RIEN
// (les tenants dont le formulaire ne fournit pas de représentant ne voient aucun changement). Couleurs : tokens --oh-* seulement.

/** Les clés lues dans `dossier.representant` (celles que la conversion écrit : prospects/contrat_formulaire.py). */
export const CHAMPS_REPRESENTANT = ["nom", "prenom", "fonction", "email", "tel", "portable"];

const plein = (v) => typeof v === "string" ? v.trim() !== "" : v != null && v !== "";

export function aUnRepresentant(r) {
  return !!r && typeof r === "object" && CHAMPS_REPRESENTANT.some((k) => plein(r[k]));
}

export function lignesRepresentant(r) {
  if (!aUnRepresentant(r)) return [];
  const identite = [r.prenom, r.nom].filter(plein).join(" ");
  const telephones = [r.tel, r.portable].filter(plein).join(" · ");
  return [
    ["Nom", identite], ["Fonction", r.fonction], ["E-mail", r.email], ["Téléphone", telephones],
  ].filter(([, v]) => plein(v));
}

export default function RepresentantDossier({ representant }) {
  const lignes = lignesRepresentant(representant);
  if (!lignes.length) return null;
  return (
    <div className="mt-3" data-testid="bloc-representant">
      <div className="text-[11px] uppercase tracking-wide mb-1" style={{ color: "var(--oh-text-muted)" }}>Représentant</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {lignes.map(([label, valeur]) => (
          <div key={label} data-testid={`representant-${label.toLowerCase().replace(/[^a-z]/g, "")}`}>
            <div className="text-xs" style={{ color: "var(--oh-text-muted)" }}>{label}</div>
            <div className="text-sm" style={{ color: "var(--oh-text)" }}>{valeur}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
